import { createHttpEndpoint } from '../../utils'

/**
 * Add a listing to the cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartAddProduct}
 */
export const addToCart = createHttpEndpoint({
  method: 'POST',
  operationId: 'addToCart',
  path: '/bm/cart/add_product',
})

/**
 * Add bundle of listings to the cart
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartAddProducts}
 */
export const addProductsToCart = createHttpEndpoint({
  method: 'POST',
  operationId: 'addProductsToCart',
  path: '/bm/cart/add_products',
})

/**
 * Update user information
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/checkout-cart-api/definition#operation/CartUpdateUserInformation}
 */
export const postUpdateUserInformation = createHttpEndpoint({
  method: 'POST',
  operationId: 'updateUserInformation',
  path: '/bm/cart/update-user-information',
})
